<div class="my-4 flex flex-col gap-4">
  @if (practice$ | async; as practice) {
    <pr-verifone-configuration #config [practice]="practice" />

    <pr-practice-verifone-terminals [practice]="practice" />

    <div>
      <button
        mat-flat-button
        color="primary"
        [disabled]="config.form.invalid"
        (click)="config.submit()"
      >
        Save
      </button>
    </div>
  }
</div>
